/* global Sys, Core */
Sys.ns("Core");

Core.gameAdapterApi = {
    BLOCK_REASON: "gameAdapterStoreBlock",

    createStore: function(services) {
        var me = this,
            buttonActions = {};

        return {
            addButtonAction: function(action, id) {
                buttonActions[id] = action || null;
            },

            getButtonAction: function(id) {
                var action = buttonActions[id];

                buttonActions = {};

                return action || null;
            },

            setBlocker: function() {
                if (!services.game.isBlocked()) {
                    services.game.blockGame(me.BLOCK_REASON);
                }
            },

            releaseBlocker: function() {
                if (services.game.isBlocked()) {
                    services.game.releaseGame(me.BLOCK_REASON);
                }
            }
        };
    },

    init: function(messageApi, services) {
        var store = this.createStore(services);

        Core.gameAdapterApi.messageActions.init(store, messageApi);

        Core.gameAdapterApi.reactions.init(store, messageApi, services);

        /*
            inform oss loader about supported features by game.
            deferOpenBetsTillIdle - call lifecycle.openBets on enteredIdleFirstTime event.
        */
        messageApi.sendMessageEvent(Core.gameAdapterApi.reactions.EVENT.INIT, {
            supports: ["deferOpenBetsTillIdle"]
        });
    }
};
